import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { BASE_URL, GET_EXECUTIVES } from '../../constant/constants';



const settings = {
  dots: false,
  arrows: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    { breakpoint: 1500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};
const PartnerSection = (props) => {
  const [executiveMembers, setExecutiveMembers] = useState([]);

  //for content images
  useEffect(() => {
    fetch(`${GET_EXECUTIVES}`)
      .then((response) => response.json())
      .then((data) => {
        setExecutiveMembers(data.executive_members);
        console.log('executive_members', data.executive_members);
      })
      .catch(() => {});
  }, []);

  console.log(`executiveMembers`, executiveMembers);
  return (
    <div className='wpo-team-area section-padding mt-5'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-lg-6'>
            <div className='wpo-section-title'>
              <span>Meet Our</span>
              <h2> Executive Member</h2>
            </div>
          </div>
        </div>
        <div className='wpo-team-wrap' style={{ width: '500px' }}>
          <div className='team-slider' >
            <Slider {...settings}>
              {executiveMembers.map((executiveMember, tm) => (
          
                    <div className='wpo-team-item' key={tm}>
                  <div className='wpo-team-img'  >
                    <img
                      src={`${BASE_URL}${executiveMember?.member?.image}`}
                      alt={executiveMember.first_name}
                      width='100%'
                      height='371'
                      className='rounded mx-4 rounded-pill'
                    />
                  </div>
                  <div className='wpo-team-content text-center mb-3' >
                    <h2>
                      {executiveMember?.member?.first_name}{' '}
                      {executiveMember?.member?.last_name}
                    </h2>
                    <span>{executiveMember?.designation}</span>
                  </div>
                </div>
             
              
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerSection;
